"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TwitterSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function TwitterSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 155.9 155.9"
  }, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".twitterSquare0{fill:#1DA1F2;}.twitterSquare1{fill:#FFFFFF !important;}"
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "twitterSquare0",
    d: "M148.1,155.9H7.8c-4.3,0-7.8-3.5-7.8-7.8V7.8C0,3.5,3.5,0,7.8,0h140.3c4.3,0,7.8,3.5,7.8,7.8v140.3 C155.9,152.4,152.4,155.9,148.1,155.9"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "twitterSquare1",
    d: "M63.5,109.6c29.4,0,45.5-24.4,45.5-45.5c0-0.7,0-1.4,0-2.1c3.1-2.3,5.8-5.1,8-8.3c-2.9,1.3-5.9,2.1-9.2,2.5 c3.3-2,5.8-5.1,7-8.8c-3.1,1.8-6.5,3.2-10.2,3.9c-2.9-3.1-7.1-5.1-11.7-5.1c-8.8,0-16,7.2-16,16c0,1.3,0.1,2.5,0.4,3.6 c-13.3-0.7-25.1-7-33-16.7c-1.4,2.4-2.2,5.1-2.2,8c0,5.5,2.8,10.4,7.1,13.3c-2.6-0.1-5.1-0.8-7.2-2c0,0.1,0,0.1,0,0.2 c0,7.7,5.5,14.2,12.8,15.7c-1.3,0.4-2.8,0.6-4.2,0.6c-1,0-2-0.1-3-0.3c2,6.4,7.9,11,14.9,11.1c-5.5,4.3-12.4,6.8-19.9,6.8 c-1.3,0-2.6-0.1-3.8-0.2C46.1,107,54.5,109.6,63.5,109.6"
  }));
}